module.exports = __webpack_public_path__ + "images/pro/img-popup-storeagefull-8c0c02968f77067603447491cd5b2e55.png";